export default __webpack_public_path__ + "static/media/Fishing_Pole.a82f6d82.png";